import {DirectionValues} from '../../d6/components/helpers';
import {markLTRWordsForRTLDirectionality} from '../../d6/components/helpers/resolveBidirectionalText';
import {getGlobal} from '../getGlobal';

const createRegExpForKey = (key: string) => {
    const regExpString = `%%${key}`;

    return new RegExp(regExpString);
};

export const replaceTranslationPlaceholders = (
    originalString: string,
    replacements: {[key: string]: string},
    direction?: DirectionValues
): string => {
    let result = originalString;

    if (!originalString) {
        return originalString;
    }

    for (const key in replacements) {
        if (replacements[key]) {
            const regExpForKey = createRegExpForKey(key);
            const headerHighlight = key === 'searchPhrase';
            const loadingResults = key === 'loadingResults';
            const ariaLivePolite = key === 'ariaLivePolite';

            if (originalString.match(regExpForKey) === null) {
                getGlobal().log.layer.debug(
                    `No placeholder found for translation replacement key: ${key} in string: ${originalString}`
                );
            }

            const resolvedText = markLTRWordsForRTLDirectionality(
                replacements[key],
                direction
            );

            if (headerHighlight) {
                result = result.replace(
                    regExpForKey,
                    `&ldquo;<strong>${resolvedText}</strong>&rdquo;`
                );
            }

            if (loadingResults) {
                result = `Loading results for ${resolvedText}`;
            }

            if (ariaLivePolite) {
                const ariaKey = createRegExpForKey('searchPhrase');

                result = result.replace(ariaKey, resolvedText);
            }

            result = result.replace(regExpForKey, resolvedText);
        }
    }

    return result;
};
